<bb-how-it-works-nav-mobile [fxHide.gt-xs]="true"></bb-how-it-works-nav-mobile>
<bb-how-it-works-nav-desktop [fxHide.xs]="true"></bb-how-it-works-nav-desktop>
